function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0b543;}.b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 47,
  cy: 47,
  r: 47
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M35,5.714V9.286C35,12.433,27.161,15,17.5,15S0,12.433,0,9.286V5.714C0,2.567,7.839,0,17.5,0S35,2.567,35,5.714Zm0,8.036v8.036c0,3.147-7.839,5.714-17.5,5.714S0,24.933,0,21.786V13.75c3.76,2.589,10.641,3.795,17.5,3.795S31.24,16.339,35,13.75Zm0,12.5v8.036C35,37.433,27.161,40,17.5,40S0,37.433,0,34.286V26.25c3.76,2.589,10.641,3.795,17.5,3.795S31.24,28.839,35,26.25Z",
  transform: "translate(29.593 27.107)"
});

function SvgIconDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatabase);
export default __webpack_public_path__ + "static/media/icon_database.870331bd.svg";
export { ForwardRef as ReactComponent };